export default __webpack_public_path__ + "static/media/linkdin.7801c4aa.svg";